export const MAX_LENGTH_RULE_NAME = "max_length";
/**
 * Validates that a string is not longer than a maximum length.
 */
export const Validator = {
    name: MAX_LENGTH_RULE_NAME,
    errorMessage: `This field may not be greater than :${MAX_LENGTH_RULE_NAME} characters.`,
    validate: (value, requirement) => value.toString().length <= Number(requirement),
};
